import { App, InstallDialog } from '../../scripts/app';
import { AppInstallModal } from './AppInstallModal';

export class AsanaApp extends App {
  public override getInstallDialog(isOrg: boolean): InstallDialog | null {
    return isOrg ? null : AppInstallModal;
  }
}
